export default __webpack_public_path__ + "static/multi-project-feature-flags-light-eab4bca4e64852bc60525541e42691fb.png";